import useTheme from "@mui/material/styles/useTheme"
import useMediaQuery from "@mui/material/useMediaQuery"

export const useWidth = () => {
  const theme = useTheme()

  const keys = [...theme.breakpoints.keys].reverse()

  // Breakpoint or null
  const ret = keys.reduce<string | null>((output, key) => {
    // https://v5.mui.com/material-ui/react-use-media-query/#migrating-from-withwidth
    // biome-ignore lint/correctness/useHookAtTopLevel: Part of migration
    const matches = useMediaQuery(theme.breakpoints.up(key))

    return !output && matches ? key : output
  }, null)

  return ret || "xs"
}

export default useWidth
